export default __webpack_public_path__ + "static/media/blog-33-image-4.d7f5dce4.jpg";